// In a component, e.g., App.js or a NotificationService.js
import { getToken } from 'firebase/messaging';
import { messaging,  } from './firebase-init'; // Adjust path as needed
import { saveFCMTokenToServer } from '../hooks/notifications';
import { useEffect } from 'react';

// VAPID key is optional but recommended for web.
// Generate it in Firebase console: Project settings > Cloud Messaging > Web configuration.
const VAPID_KEY = "BK-dsMKSHWVmtWUjI6sjfhLoS7gYOAj-hAE7PwhfMtMeAxEbghjMl8KB9wb_MvEwEg0oIka2jf0obOU9TLfK4A8";

export async function requestForToken() {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      console.log('Notification permission granted.');

      // Get registration token. Initially this makes a network call, once retrieved
      // subsequent calls to getToken will return from cache.
      const currentToken = await getToken(messaging, { vapidKey: VAPID_KEY });
      if (currentToken) {
        sendTokenToServer(currentToken);
        console.log('Current FCM token saved:', currentToken);
        return currentToken;
      } else {
        console.log('No registration token available. Request permission to generate one.');
      }
    } else {
      console.log('Unable to get permission to notify.');
    }
  } catch (err) {
    console.log('An error occurred while retrieving token. ', err);
  }
}

async function sendTokenToServer(token:any) {
  try {
    const response = await saveFCMTokenToServer(token);

    if (response?.success) {
      console.log('FCM token sent to Django successfully!');
    } else {
      console.error('Failed to send FCM token to Django:', response?.data);
    }
  } catch (error) {
    console.error('Error sending FCM token to Django:', error);
  }
}

export const FCMTokenGetSend = () => {
  useEffect(() => {
    const requestPermissionAndSaveToken = async () => {
      try {
        if (!messaging) {
          console.warn("Firebase messaging not supported on this browser.");
          return;
        }

        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
          console.warn("Notification permission denied.");
          return;
        }

        const token = await getToken(messaging, { vapidKey: VAPID_KEY });
        if (token) {
          console.log("✅ FCM token acquired:", token);
          const response = await saveFCMTokenToServer(token);
          console.log('Notification token saved.', response?.data);
        } else {
          console.warn("❗ No token received.");
        }
      } catch (error) {
        console.error("❌ Error retrieving FCM token:", error);
      }
    };

    requestPermissionAndSaveToken();

  }, []);

  return null;
};